import { useTranslation } from 'react-i18next';

import { useAuthenticatedUser, useFeature } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Button, Jumbo } from '@treams/treams-ui';

import OutgoingConversationsList from './OutgoingConversationsList';
import ViewerConversationTabs from './ViewerConversationTabs';

export default function ViewerOutgoingConversations() {
	const { t } = useTranslation();
	const userID = useAuthenticatedUser().id;
	const isAdhocEnabled = useFeature(graphql.FeatureName.EvaluationsAdhoc);

	const query = graphql.useOutgoingEvaluationSubmissionsQuery({
		variables: { userID, isArchived: false, last: 5 },
	});

	const [fetchArchived, archivedQuery] = graphql.useOutgoingEvaluationSubmissionsLazyQuery({
		variables: { userID, isArchived: true, last: 5 },
	});

	return (
		<>
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.ConversationsOutgoing}
				title={t('conversations.index.title')}
				description={t('conversations.index.description')}
				button={
					isAdhocEnabled && (
						<Button
							icon={<AddIcon />}
							title={t('conversations.index.new')}
							link="/conversations/request-from-moment"
						/>
					)
				}
				footer={<ViewerConversationTabs />}
			/>

			<OutgoingConversationsList
				fetchArchived={fetchArchived}
				archivedQuery={archivedQuery}
				query={query}
			/>
		</>
	);
}
